import { render, staticRenderFns } from "./Booths.vue?vue&type=template&id=3bae1f93"
import script from "./Booths.vue?vue&type=script&lang=js"
export * from "./Booths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports